// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-n_fU","advertDetailHeaderLocation__value":"c-n_fV"};